import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function UykuApnesiRiskiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['uyku-apnesi-riski-testi']} />;
}
